import request from '@/utils/request'
// import { filterNullParams } from '@/utils/filterNullParams/filterNullParams'

export function getDataReport(params) {
  return request({
    url: `data_insight/ad_data_insights`,
    method: 'get',
    params
  })
}
// 获取日/小时报表（整合）
export function getDateHourReport(params) {
  return request({
    url: `/data_insight/ad_reports`,
    method: 'get',
    params
  })
}
// 获取日/小时报表（整合）
export function advertTypeSelectList(params) {
  return request({
    url: `/data_insight/get_select_list`,
    method: 'get',
    params
  })
}
// 创建企业微信客服组
export function wechatcorpcreate(data) {
  return request({
    url: '/wechatCorp/forward',
    method: 'post',
    data
  })
}
// 微信客服组列表
export function getselectlist(params) {
  return request({
    url: '/wechatCorp/forward',
    method: 'get',
    params
  })
}
// 获取广告企业列表
export function getcorpList(params) {
  return request({
    url: '/wechatCorp/forward',
    method: 'get',
    params
  })
}
// 广告企业下员工
export function getwechatcorpuser(params) {
  return request({
    url: '/wechatCorp/forward',
    method: 'get',
    params
  })
}
// 修改客服组
export function updateCorpCsGroupal(data) {
  return request({
    url: '/wechatCorp/forward',
    method: 'post',
    data
  })
}
// 广告企业微信客服组
export function getcorpcsgrouplist(params) {
  return request({
    url: '/wechatCorp/forward',
    method: 'get',
    params
  })
}
// 广告企业微信客服集
export function adGroupSetList(params) {
  return request({
    url: '/wechatCorp/forward',
    method: 'get',
    params
  })
}
// 修改客服组输入框
export function updateClickAddNumber(data) {
  return request({
    url: '/wechatCorp/forward',
    method: 'post',
    data
  })
}
// 修改客服组时间输入框
export function updateEstimatedMaxTime(data) {
  return request({
    url: '/wechatCorp/forward',
    method: 'post',
    data
  })
}
